import React from 'react';
// Target pane (sprites) removed — not used in program mode
const TargetPane = () => null;
export default TargetPane;
